import React from 'react';

import { Controller, useFormContext } from 'react-hook-form';

import { QueryResponse as Risk } from 'api/queries/getRisk.query';

import { MyCustomSelect } from 'components/common';
import { distributionOptions } from 'components/widgets/RiskRegister/RiskRegister.utils';
import classes from 'components/widgets/RiskRegister/components/RiskRegisterRoutes/components/Details/Details.module.scss';

export const Distribution = () => {
    const { setValue, control } = useFormContext<Risk>();
    return (
        <div className={classes.selectWrapper}>
            <div className={classes.title}>Distribution:</div>
            <div data-testid={'distribution'} className={classes.content}>
                <Controller
                    render={({ field }) => (
                        <MyCustomSelect<ISelectOption<Risk['distribution']>>
                            {...field}
                            value={distributionOptions.find((option) => option.value === field.value)}
                            onChange={(value) => value && setValue('distribution', value.value, { shouldDirty: true })}
                            options={distributionOptions}
                            placeholder="Select distribution"
                            isClearable={false}
                        />
                    )}
                    name="distribution"
                    control={control}
                />
            </div>
        </div>
    );
};
